import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "commonLayout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_HomeHeader = _resolveComponent("HomeHeader")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "mainContainer" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, { width: "250px" }, {
          default: _withCtx(() => [
            _createVNode(_component_MainMenu)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "contentContainer" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_HomeHeader)
              ]),
              _: 1
            }),
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}